import React, { FC } from 'react';
import { ErrorIconCont, InputLabel, InputWrapper, StyledInput } from './Input.styles';
import ErrorInputIcon from '@/assets/icons/errorInputIcon.svg?react';

interface InputProps {
  onChange: (val: string) => void;
  value: string;
  label?: string;
  error?: string;
  placeholder?: string;
}

const Input: FC<InputProps> = ({ onChange, value, label, error, placeholder }) => {
  return (
    <InputWrapper>
      {label && <InputLabel>{label}</InputLabel>}
      <StyledInput
        data-testid="inputModal"
        error={!!error}
        placeholder={placeholder || ''}
        name="input"
        id="1"
        value={value}
        onChange={({ target }) => onChange(target.value)}
      />
      {!!error && (
        <ErrorIconCont>
          <ErrorInputIcon />
        </ErrorIconCont>
      )}
    </InputWrapper>
  );
};

export default Input;
